
(()=> {
 const cfgEl=document.getElementById('DoreLayoutConfig');
 let cfg={};try{cfg=JSON.parse(cfgEl?.textContent||'{}')}catch(e){cfg={}}
 const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];
 // Remember scroll position only when language or market localization is changed.
 const localeScrollKey='dore-localization-scroll-v1';
 const localePagePath=pathname=>{
   const withoutLocale=String(pathname||'/').replace(/^\/(?:de|fr|it|en|es)(?=\/|$)/i,'')||'/';
   return withoutLocale.replace(/\/+$/,'')||'/';
 };
 const readLocaleScroll=()=>{
   try{
     const saved=JSON.parse(sessionStorage.getItem(localeScrollKey)||'null');
     if(!saved||saved.path!==localePagePath(location.pathname)||Date.now()-saved.at>60000){
       sessionStorage.removeItem(localeScrollKey);return null;
     }
     return saved;
   }catch(_){return null}
 };
 const saveLocaleScroll=form=>{
   try{
     const previous=readLocaleScroll();
     const y=Math.max(0,Math.round(window.scrollY||window.pageYOffset||0));
     // Shopify may perform a second redirect from an interim page at scroll 0.
     if(previous&&y<3&&previous.y>3)return;
     const localeField=form.querySelector('input[data-dore-locale],input[name="locale_code"]');
     const marketField=form.querySelector('select[name="country_code"]');
     sessionStorage.setItem(localeScrollKey,JSON.stringify({
       path:localePagePath(location.pathname),y,at:Date.now(),
       locale:localeField?.value||null,country:marketField?.value||null
     }));
   }catch(_){}
 };
 document.addEventListener('submit',event=>{
   if(event.target?.matches?.('.ds-lang-form,.ds-mobile-lang-form,.ds-country-form'))
     saveLocaleScroll(event.target);
 },true);
 // A direct native form.submit() may not fire submit, but select change does.
 document.addEventListener('change',event=>{
   if(event.target?.matches?.('.ds-country-form select[name="country_code"]'))
     saveLocaleScroll(event.target.form);
 },true);
 const pendingLocaleScroll=readLocaleScroll();
 if(pendingLocaleScroll){
   const targetReady=(!pendingLocaleScroll.country||cfg.country===pendingLocaleScroll.country)
     &&(!pendingLocaleScroll.locale||document.documentElement.lang.toLowerCase().split('-')[0]===pendingLocaleScroll.locale);
   if(targetReady){
     let cancelled=false;
     const cancelByUser=()=>{cancelled=true;try{sessionStorage.removeItem(localeScrollKey)}catch(_){}};
     ['wheel','touchstart','pointerdown','keydown'].forEach(type=>window.addEventListener(type,cancelByUser,{once:true,passive:true}));
     const restorePosition=()=>{
       if(cancelled)return;
       const maxY=Math.max(0,document.documentElement.scrollHeight-window.innerHeight);
       const y=Math.min(pendingLocaleScroll.y,maxY);
       const html=document.documentElement,old=html.style.scrollBehavior;
       html.style.scrollBehavior='auto';
       window.scrollTo(0,y);
       html.style.scrollBehavior=old;
     };
     requestAnimationFrame(()=>requestAnimationFrame(restorePosition));
     if(document.readyState==='complete')restorePosition();
     else window.addEventListener('load',restorePosition,{once:true});
     setTimeout(()=>{restorePosition();try{sessionStorage.removeItem(localeScrollKey)}catch(_){}},400);
   }
 }

 // Localization forms generated by Shopify include a return_to field. URLs with
 // ?country= or ?currency= can override a country selection after redirect.
 // Preserve the page and other relevant parameters, but remove market test params.
 document.querySelectorAll('.ds-country-form,.ds-lang-form,.ds-mobile-lang-form').forEach(form=>{
   form.addEventListener('submit',()=>{
     const next=new URL(window.location.href);
     next.searchParams.delete('country');
     next.searchParams.delete('currency');
     let field=form.querySelector('input[name="return_to"]');
     if(!field){field=document.createElement('input');field.type='hidden';field.name='return_to';form.appendChild(field)}
     field.value=next.pathname+next.search+next.hash;
   });
 });
 const localeRoot=(()=>{const r=String(cfg.rootUrl||'/');return r.endsWith('/')?r:r+'/';})();
 const esc=s=>String(s??'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));
 const drawer=$('[data-ds-drawer]'), backdrop=$('[data-ds-backdrop]'), cartDrawer=$('[data-ds-cart-drawer]');
 const openDrawer=()=>{drawer?.classList.add('is-open');backdrop?.classList.add('is-open');drawer?.setAttribute('aria-hidden','false');drawer?.removeAttribute('inert');document.documentElement.style.overflow='hidden'};
 const closeDrawer=()=>{drawer?.classList.remove('is-open');drawer?.setAttribute('aria-hidden','true');drawer?.setAttribute('inert','');if(!cartDrawer?.classList.contains('is-open')){backdrop?.classList.remove('is-open');document.documentElement.style.overflow=''}};
 const menuButton=$('[data-ds-menu]');

 const openMenuOnce=e=>{e?.preventDefault?.();if(drawer?.classList.contains('is-open'))return;openDrawer()};
 menuButton?.addEventListener('pointerup',openMenuOnce);
 menuButton?.addEventListener('click',e=>{if(e.detail===0)openMenuOnce(e)});
 $('[data-ds-close]')?.addEventListener('click',closeDrawer);
 $$('.ds-drawer a').forEach(a=>a.addEventListener('click',closeDrawer));
 document.querySelectorAll('.ds-lang-form,.ds-mobile-lang-form').forEach(form=>{
   const buttons=[...form.querySelectorAll('button[name="locale_code"]')];
   buttons.forEach(b=>{
     b.addEventListener('click',e=>{
       e.preventDefault();
       if(b.classList.contains('is-active')||form.dataset.doreSubmitting==='1')return;
       form.dataset.doreSubmitting='1';
       document.querySelectorAll('.ds-lang-form button,.ds-mobile-lang-form button').forEach(x=>x.classList.toggle('is-active',x.value===b.value));
       let localeInput=form.querySelector('input[data-dore-locale]');
       if(!localeInput){
         localeInput=document.createElement('input');
         localeInput.type='hidden';
         localeInput.name='locale_code';
         localeInput.dataset.doreLocale='1';
         form.appendChild(localeInput);
       }
       localeInput.value=b.value;
       document.documentElement.classList.add('ds-lang-switching');
       form.requestSubmit ? form.requestSubmit() : form.submit();
     });
   });
 });

 // Market and currency are distinct in Shopify. Legacy ?country=DE and
 // ?currency=EUR override the displayed currency without activating the DE
 // Market and its EUR price list. Commit the country using Shopify's official
 // localization form rather than formatting converted CHF prices as EUR.
 (()=>{
   const allowed={CH:'CHF',DE:'EUR'};
   const params=new URLSearchParams(window.location.search);
   const countryParam=params.get('country')?.toUpperCase();
   const currencyParam=params.get('currency')?.toUpperCase();
   const validCountry=Object.prototype.hasOwnProperty.call(allowed,countryParam);
   const legacy=validCountry||currencyParam==='CHF'||currencyParam==='EUR';
   const target=(validCountry)
     ?countryParam
     :(currencyParam==='EUR'?'DE':currencyParam==='CHF'?'CH':cfg.country);
   if(!(target in allowed))return;
   const clean=new URL(window.location.href);
   clean.searchParams.delete('country');
   clean.searchParams.delete('currency');
   const cleanReturn=clean.pathname+clean.search+clean.hash;
   const marketMismatch=cfg.country!==target||cfg.currency!==allowed[target];
   if(!legacy&&!marketMismatch)return;
   if(!marketMismatch){
     // A completed switch must not block an immediate switch back.
     try{sessionStorage.removeItem('dore-market-sync:'+target+':'+clean.pathname)}catch(_){}
     if(legacy)history.replaceState(history.state,'',cleanReturn);
     return;
   }
   const form=document.querySelector('.ds-country-form');
   const select=form?.querySelector('select[name="country_code"]');
   if(!form||!select)return;
   // Prevent repeated submissions if a market cannot be activated.
   const key='dore-market-sync:'+target+':'+clean.pathname;
   let attempted=false;
   try{
     attempted=Date.now()-Number(sessionStorage.getItem(key)||0)<60000;
   }catch(_){}
   if(attempted)return;
   try{sessionStorage.setItem(key,String(Date.now()))}catch(_){}
   select.value=target;
   let field=form.querySelector('input[name="return_to"]');
   if(!field){field=document.createElement('input');field.type='hidden';field.name='return_to';form.appendChild(field)}
   field.value=cleanReturn;
   form.requestSubmit?form.requestSubmit():form.submit();
 })();
 const search=$('[data-ds-search-panel]'), input=$('[data-ds-search-input]'), results=$('[data-ds-search-results]');
 // Die Lupe oeffnet im Neuaufbau den bestehenden Duftberater statt eines zweiten Such-Panels.
 $('[data-ds-search]')?.addEventListener('click',()=>{
   search?.classList.remove('is-open');
   window.DoreOpenAdvisor?.();
 });
 $('[data-ds-search-close]')?.addEventListener('click',()=>search?.classList.remove('is-open'));
 let searchTimer;
 input?.addEventListener('input',()=>{clearTimeout(searchTimer);const q=input.value.trim();if(q.length<2){results.innerHTML='';return}searchTimer=setTimeout(async()=>{try{const r=await fetch(localeRoot+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6');const j=await r.json();const products=j?.resources?.results?.products||[];results.innerHTML=products.map(p=>'<a class="ds-search-card" href="'+esc(p.url)+'"><img src="'+esc(p.image||'')+'" alt=""><div><strong>'+esc(p.title)+'</strong><small>'+esc(p.price||'')+'</small></div></a>').join('')||'<div>'+cfg.searchEmpty+'</div>'}catch(e){}},180)});
 const cartBody=$('[data-ds-cart-body]'),cartTotal=$('[data-ds-cart-total]'),shipProgress=$('[data-ds-shipping-progress]'),shipCopy=$('[data-ds-shipping-copy]'),checkoutLink=$('[data-ds-checkout]'),cartHeadCount=$('[data-ds-cart-head-count]'),cartSaving=$('[data-ds-cart-saving]'),cartSavingValue=$('[data-ds-cart-saving-value]');
 const money=cents=>{const currency=window.Shopify?.currency?.active||cfg.currency||'CHF';const amount=(Number(cents)||0)/100;return currency==='CHF'?'CHF '+amount.toFixed(2):new Intl.NumberFormat(document.documentElement.lang||'de-CH',{style:'currency',currency}).format(amount)};
 async function getCart(){const r=await fetch(localeRoot+'cart.js',{headers:{Accept:'application/json'}});if(!r.ok)throw new Error('Cart fetch failed');return r.json()}
 async function renderCart(open=false){if(open){cartDrawer?.classList.add('is-open');cartDrawer?.setAttribute('aria-hidden','false');cartDrawer?.removeAttribute('inert');backdrop?.classList.add('is-open');document.documentElement.style.overflow='hidden';if(cartBody&&!cartBody.children.length)cartBody.innerHTML='<div class="ds-cart-loading"><span></span><span>'+cfg.cartLabel+'…</span></div>'}try{const c=await getCart();$$('[data-ds-cart-count]').forEach(el=>{el.textContent=c.item_count;el.classList.toggle('is-empty',!c.item_count)});if(cartHeadCount)cartHeadCount.textContent=c.item_count?'('+c.item_count+')':'';cartTotal.textContent=money(c.total_price);if(cartSaving&&cartSavingValue){const s=Number(c.total_discount)||0;cartSaving.style.display=s>0?'flex':'none';cartSavingValue.textContent=s>0?'− '+money(s):''}const isSwissMarket=cfg.country==='CH'&&cfg.currency==='CHF';const isGermanMarket=cfg.country==='DE'&&cfg.currency==='EUR';const hasFreeShipping=isSwissMarket||isGermanMarket;const threshold=9000,pct=Math.min(100,c.total_price/threshold*100);shipProgress.style.width=hasFreeShipping?pct+'%':'0%';shipCopy.textContent=hasFreeShipping?(c.total_price>=threshold?cfg.shipDone:(cfg.shipPrefix+' '+money(threshold-c.total_price)+' '+cfg.shipUntil)):(document.documentElement.lang.startsWith('de')?'Versandkosten im Checkout':'Shipping calculated at checkout');checkoutLink.style.display=c.item_count?'grid':'none';cartBody.innerHTML=c.items.length?c.items.map((it,i)=>'<div class="ds-cart-item"><a href="'+esc(it.url||'#')+'"><img src="'+esc(it.image||'')+'" alt="'+esc(it.product_title)+'"></a><div class="ds-cart-item-copy"><a href="'+esc(it.url||'#')+'"><strong>'+esc(it.product_title)+'</strong></a><small>'+esc(it.variant_title&&it.variant_title!=='Default Title'?it.variant_title:'50 ml')+'</small><div class="ds-qty"><button type="button" data-ds-qty data-line="'+(i+1)+'" data-q="'+Math.max(0,it.quantity-1)+'">−</button><span>'+it.quantity+'</span><button type="button" data-ds-qty data-line="'+(i+1)+'" data-q="'+(it.quantity+1)+'">+</button></div></div><div class="ds-cart-price">'+((it.original_line_price||0)>(it.final_line_price||0)?'<s>'+money(it.original_line_price)+'</s>':'')+money(it.final_line_price)+'</div></div>').join(''):'<p>'+cfg.cartEmpty+'<a class="ds-empty-cart-cta" href="'+esc(cfg.allScentsUrl)+'">'+cfg.navAll+' →</a></p>';$$('[data-ds-qty]',cartBody).forEach(b=>b.addEventListener('click',async()=>{try{b.disabled=true;const response=await fetch(localeRoot+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(b.dataset.line),quantity:Number(b.dataset.q)})});if(!response.ok)throw new Error('Cart change failed');await renderCart()}catch(err){toast(cfg.addFailed)}finally{b.disabled=false}}));}catch(e){if(cartBody)cartBody.innerHTML='<p>'+cfg.cartEmpty+'</p>'}}
 function closeCart(){cartDrawer?.classList.remove('is-open');cartDrawer?.setAttribute('aria-hidden','true');cartDrawer?.setAttribute('inert','');if(!drawer?.classList.contains('is-open')){backdrop?.classList.remove('is-open');document.documentElement.style.overflow=''}}
 const cartOpen=$('[data-ds-cart-open]');

 const openCartOnce=e=>{e?.preventDefault?.();if(cartDrawer?.classList.contains('is-open'))return;renderCart(true)};
 cartOpen?.addEventListener('pointerup',openCartOnce);
 cartOpen?.addEventListener('click',e=>{if(e.detail===0)openCartOnce(e)});
 $('[data-ds-cart-close]')?.addEventListener('click',closeCart);backdrop?.addEventListener('click',()=>{closeDrawer();closeCart()});
 async function applyDiscountBox(box){
   const input=box.querySelector('[data-ds-discount-input]');
   const status=box.querySelector('[data-ds-discount-status]');
   const button=box.querySelector('[data-ds-discount-apply]')||box.querySelector('button[type="submit"]');
   const code=String(input?.value||'').trim();
   if(!code)return;
   if(button)button.disabled=true;
   if(status){status.textContent='';status.classList.remove('is-error','is-success')}
   try{
     const r=await fetch(localeRoot+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:code})});
     const cart=await r.json();
     const found=(cart.discount_codes||[]).find(d=>String(d.code||'').toLowerCase()===code.toLowerCase());
     const ok=r.ok && Boolean(found) && found.applicable!==false;
     if(!ok)throw new Error('discount');
     if(status){status.textContent=cfg.discountSuccess||'Rabattcode angewendet';status.classList.add('is-success')}
     if(cartDrawer?.classList.contains('is-open')) await renderCart(false);
     else setTimeout(()=>window.location.reload(),450);
   }catch(err){
     if(status){status.textContent=cfg.discountInvalid||'Rabattcode ungültig';status.classList.add('is-error')}
   }finally{if(button)button.disabled=false}
 }
 $$('[data-ds-discount-form]').forEach(box=>{
   if(box.tagName==='FORM')box.addEventListener('submit',e=>{e.preventDefault();applyDiscountBox(box)});
   box.querySelector('[data-ds-discount-apply]')?.addEventListener('click',e=>{e.preventDefault();applyDiscountBox(box)});
 });
 document.addEventListener('click',async e=>{const b=e.target.closest('[data-dore-add]');if(!b)return;e.preventDefault();const id=Number(b.dataset.variant);if(!id)return;b.disabled=true;try{const response=await fetch(localeRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});if(!response.ok)throw new Error('Cart add failed: '+response.status);toast(cfg.addedToCart);await renderCart(true)}catch(err){toast(cfg.addFailed)}finally{b.disabled=false}});
 function toast(t){const el=$('[data-ds-toast]');if(!el)return;el.textContent=t;el.classList.add('is-show');setTimeout(()=>el.classList.remove('is-show'),1700)}
 window.DoreCart={render:renderCart,toast};
})();

;(()=>{
  const root=document.querySelector('[data-ds-advisor-lazy]');
  if(!root)return;
  const btn=root.querySelector('[data-ds-advisor-open]');
  const tpl=root.querySelector('[data-ds-advisor-template]');
  let loading=null;
  const loadCss=url=>new Promise(resolve=>{
    if(!url)return resolve();
    const found=[...document.querySelectorAll('link[rel="stylesheet"]')].some(l=>l.href===url);
    if(found)return resolve();
    const link=document.createElement('link');link.rel='stylesheet';link.href=url;
    link.onload=()=>resolve();link.onerror=()=>resolve();document.head.appendChild(link);
  });
  const loadJs=url=>new Promise((resolve,reject)=>{
    if(!url)return resolve();
    const old=document.querySelector('script[data-dore-advisor-runtime]');
    if(old){if(old.dataset.loaded==='1')return resolve();old.addEventListener('load',resolve,{once:true});return;}
    const s=document.createElement('script');s.src=url;s.defer=true;s.dataset.doreAdvisorRuntime='1';
    s.onload=()=>{s.dataset.loaded='1';resolve()};s.onerror=reject;document.head.appendChild(s);
  });
  const load=()=>{
    if(root.dataset.advisorReady==='1')return Promise.resolve();
    if(loading)return loading;
    if(tpl){root.appendChild(tpl.content.cloneNode(true));tpl.remove();}
    root.classList.add('is-loading');
    loading=Promise.all([loadCss(root.dataset.advisorCss),loadJs(root.dataset.advisorJs)]).then(()=>{
      root.dataset.advisorReady='1';root.classList.remove('is-loading');
    }).catch(()=>{root.classList.remove('is-loading')});
    return loading;
  };
  // DORE NEUAUFBAU: dezenter Duftberater-Hinweis statt automatischem Chatfenster.
  // Gilt auf jeder Shopseite. Keine mehrtaegigen Sperren, nur pro offenem Tab.
  const nudge=root.querySelector('[data-ds-advisor-nudge]');
  const nudgeOpen=root.querySelector('[data-ds-advisor-nudge-open]');
  const nudgeClose=root.querySelector('[data-ds-advisor-nudge-close]');
  const shownKey='dore-advisor-nudge-shown-tab-v5';
  const dismissedKey='dore-advisor-nudge-dismissed-tab-v5';
  // Explizite Vorschau: nach der regulären Wartezeit auch nach früheren Tests zeigen.
  const nudgePreview=new URLSearchParams(location.search).get('nudgepreview')==='1';
  const sessionFallback=Object.create(null);
  const readPreference=key=>{
    try{return sessionStorage.getItem(key)==='1'}catch(_){return !!sessionFallback[key]}
  };
  const savePreference=key=>{
    sessionFallback[key]=true;
    try{sessionStorage.setItem(key,'1')}catch(_){}
  };
  let automaticCancelled=false;
  const hideNudge=()=>{if(nudge)nudge.hidden=true};
  const markVisited=()=>{
    savePreference(shownKey);
    hideNudge();
  };
  const dismissNudge=()=>{
    automaticCancelled=true;
    savePreference(dismissedKey);
    markVisited();
  };
  const manuallyOpen=()=>{
    automaticCancelled=true;
    markVisited();
    return load().then(()=>{
      if(root.dataset.advisorReady!=='1'||root.classList.contains('is-open'))return;
      btn?.click();
    });
  };
  // Bestehender Chat wird nur bei ausdruecklichem Klick geladen/geoeffnet.
  window.DoreOpenAdvisor=manuallyOpen;
  btn?.addEventListener('click',e=>{
    if(e.isTrusted){
      automaticCancelled=true;
      markVisited();
    }
    if(root.dataset.advisorReady==='1')return;
    e.preventDefault();
    e.stopImmediatePropagation();
    manuallyOpen();
  });
  nudgeOpen?.addEventListener('click',manuallyOpen);
  nudgeClose?.addEventListener('click',e=>{
    e.preventDefault();
    e.stopPropagation();
    dismissNudge();
  });
  document.addEventListener('click',e=>{
    const a=e.target.closest('a[href*="#duft-finder"]');
    if(!a)return;
    e.preventDefault();
    manuallyOpen();
  });
  // 5s Desktop / 6s Mobile, keine Scrollpflicht und keine Popups auf Produktfotos.
  // Bei offenem Cookie-Banner oder Navigation wird der Hinweis spaeter angezeigt.
  const autoDelay=window.matchMedia('(max-width: 760px)').matches?6000:5000;
  const canShowNudge=()=>{
    // Only the desktop homepage may show the automatic hint; chat icon stays available everywhere.
    if(window.matchMedia('(max-width: 760px)').matches || !document.body.classList.contains('ds-page-index'))return false;
    if(!nudge||automaticCancelled||(!nudgePreview&&(readPreference(shownKey)||readPreference(dismissedKey))))return false;
    if(document.visibilityState!=='visible'||root.classList.contains('is-open'))return false;
    if(document.documentElement.classList.contains('ds-cookie-open'))return false;
    if(document.querySelector('.ds-drawer.is-open,.ds-cart-drawer.is-open,.ds-search.is-open'))return false;
    if(document.activeElement?.matches('input,textarea,select,[contenteditable="true"]'))return false;
    return true;
  };
  const tryNudge=()=>{
    if(automaticCancelled||(!nudgePreview&&(readPreference(shownKey)||readPreference(dismissedKey))))return;
    if(!canShowNudge()){
      setTimeout(tryNudge,1250);
      return;
    }
    nudge.hidden=false;
    savePreference(shownKey);
  };
  if(nudge&&!window.matchMedia('(max-width: 760px)').matches&&document.body.classList.contains('ds-page-index')&&(nudgePreview||(!readPreference(shownKey)&&!readPreference(dismissedKey)))){
    setTimeout(tryNudge,autoDelay);
  }
  document.addEventListener('dore:advisor-closed',dismissNudge);
})();

;(()=>{
  const root=document.querySelector('[data-ds-cookie]');
  if(!root||!window.Shopify?.loadFeatures)return;
  const banner=root.querySelector('[data-ds-cookie-banner]');
  const prefs=root.querySelector('[data-ds-cookie-prefs]');
  const analytics=root.querySelector('[data-ds-cookie-analytics]');
  const marketing=root.querySelector('[data-ds-cookie-marketing]');
  const open=()=>{root.hidden=false;banner.hidden=false;prefs.hidden=true;document.documentElement.classList.add('ds-cookie-open')};
  const close=()=>{root.hidden=true;document.documentElement.classList.remove('ds-cookie-open')};
  const current=cp=>{
    try{
      if(analytics)analytics.checked=!!cp.analyticsProcessingAllowed();
      if(marketing)marketing.checked=!!cp.marketingAllowed();
    }catch(e){}
  };
  const errorText={
    de:'Deine Cookie-Auswahl konnte nicht gespeichert werden. Bitte versuche es erneut.',
    fr:"Impossible d’enregistrer vos préférences de cookies. Veuillez réessayer.",
    it:'Impossibile salvare le preferenze sui cookie. Riprova.',
    es:'No se han podido guardar tus preferencias de cookies. Inténtalo de nuevo.',
    en:'Your cookie preferences could not be saved. Please try again.'
  };
  const buttons=[...root.querySelectorAll('[data-ds-cookie-accept],[data-ds-cookie-reject],[data-ds-cookie-save]')];
  let pending=false;
  const showError=()=>{
    for(const panel of [banner,prefs]){
      let notice=panel.querySelector('[data-ds-cookie-error]');
      if(!notice){
        notice=document.createElement('p');
        notice.dataset.dsCookieError='';
        notice.setAttribute('role','alert');
        notice.style.cssText='font-size:13px;margin-top:12px;color:#ffcb88;';
        panel.appendChild(notice);
      }
      notice.textContent=errorText[(document.documentElement.lang||'de').split('-')[0]]||errorText.de;
      notice.hidden=false;
    }
  };
  const clearError=()=>{
    root.querySelectorAll('[data-ds-cookie-error]').forEach(notice=>notice.hidden=true);
  };
  const save=(all)=>{
    if(pending)return;
    const cp=window.Shopify?.customerPrivacy;
    if(typeof cp?.setTrackingConsent!=='function'){showError();return;}
    const yes=all===true;
    const no=all===false;
    const payload={
      analytics:yes?true:no?false:!!analytics?.checked,
      marketing:yes?true:no?false:!!marketing?.checked,
      preferences:yes?true:no?false:true
    };
    clearError();
    pending=true;
    buttons.forEach(b=>b.disabled=true);
    const finish=(success)=>{
      pending=false;
      buttons.forEach(b=>b.disabled=false);
      if(success)close();
      else showError();
    };
    let completed=false;
    const timer=setTimeout(()=>{
      if(completed)return;
      completed=true;
      finish(false);
    },8000);
    try{
      cp.setTrackingConsent(payload,result=>{
        if(completed)return;
        completed=true;
        clearTimeout(timer);
        finish(!(result && result.error));
      });
    }catch(error){
      if(completed)return;
      completed=true;
      clearTimeout(timer);
      finish(false);
    }
  };
  root.querySelector('[data-ds-cookie-accept]')?.addEventListener('click',()=>save(true));
  root.querySelector('[data-ds-cookie-reject]')?.addEventListener('click',()=>save(false));
  root.querySelector('[data-ds-cookie-settings]')?.addEventListener('click',()=>{banner.hidden=true;prefs.hidden=false});
  root.querySelector('[data-ds-cookie-back]')?.addEventListener('click',()=>{prefs.hidden=true;banner.hidden=false});
  root.querySelector('[data-ds-cookie-save]')?.addEventListener('click',()=>save(null));
  document.querySelectorAll('[data-ds-cookie-reopen]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();open();try{current(window.Shopify.customerPrivacy)}catch(_){}}));
  window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{
    if(error)return;
    const cp=window.Shopify.customerPrivacy;
    if(!cp)return;
    current(cp);
    let show=false;
    try{
      const consent=typeof cp.currentVisitorConsent==='function'?cp.currentVisitorConsent():null;
      show=consent ? (consent.analytics==='' || consent.marketing==='') :
        (typeof cp.shouldShowBanner==='function' && cp.shouldShowBanner());
    }catch(e){
      try{show=typeof cp.shouldShowBanner==='function' && cp.shouldShowBanner()}catch(_){}
    }
    if(new URLSearchParams(location.search).get('cookiepreview')==='1')show=true;
    if(show)open(); else close();
  });
  window.DoreCookieConsent={open};
})();

/* DoreFooterLegalTracking: custom legal-link events; no external request or cookie. */
;(() => {
  'use strict';
  const names = {
    '/pages/impressum': 'impressum',
    '/pages/agb': 'agb',
    '/pages/rueckgabe-retouren': 'rueckgabe_retouren',
    '/policies/privacy-policy': 'datenschutz',
    '/pages/haftungsausschluss': 'haftungsausschluss'
  };
  document.addEventListener('click', event => {
    const origin = event.target;
    if (!origin || typeof origin.closest !== 'function') return;
    const link = origin.closest('.ds-footer a[href]');
    if (!link) return;
    let legalPage;
    try {
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin) return;
      const path = url.pathname.replace(/^\/(?:de|fr|it|en|es)(?=\/)/, '').replace(/\/$/, '');
      legalPage = names[path];
    } catch (_) { return; }
    if (!legalPage) return;
    // Additional analytics are optional; never transmit before consent.
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return;
    try { if (!privacy.analyticsProcessingAllowed()) return; } catch (_) { return; }
    const payload = { legal_page: legalPage, link_location: 'footer' };
    try {
      const publish = window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish;
      if (typeof publish === 'function') {
        const result = publish.call(window.Shopify.analytics, 'dore:footer_legal_click', payload);
        if (result && typeof result.catch === 'function') result.catch(() => {});
      }
    } catch (_) { /* Never block navigation. */ }
    // Compatible with an existing GA4 tag; no new Google tag is loaded.
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'dore_footer_legal_click', {
          legal_page: legalPage,
          link_location: 'footer',
          transport_type: 'beacon'
        });
      }
    } catch (_) { /* Never block navigation. */ }
  }, true);
})();
